import $ from 'jquery'
import { getReactScriptsLoader } from './utils/loadScript'

const initScripts = getReactScriptsLoader(['/dist/PannableAttributes.js'], () => {
  if (!!window.PannableAttributes) return true
  // this is to fix some weird race condition where the script hasn't been parsed by browser when this callback fires
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (!window.PannableAttributes) reject('PannableAttributes not found')
      else resolve()
    }, 50)
  })
})

export function initialise() {
  mountDraggableAttributes()
}

function mountDraggableAttributes() {
  const $elems = $('[data-pannable-attributes]')
  if (!$elems.length) return
  initScripts()
    .then(() => {
      if (!window.PannableAttributes) {
        console.log('PannableAttributes initializer not found on window')
        return
      }
      $elems.each((i, elem) => {
        const $wrapper = $(elem)
        const $container = $wrapper.find('.attributes')
        const values = $container
          .find('.attribute')
          .toArray()
          .map((elem) => ({ text: elem.innerHTML, className: elem.className }))
        window.PannableAttributes.init(elem, {
          values,
          wrapperClass: $wrapper.attr('class'),
          containerClass: $container.attr('class'),
        })
      })
    })
    .catch((err) => {
      console.warn(err)
    })
}

function unmountDraggableAttributes() {
  const $elems = $('[data-pannable-attributes]')
  $elems.each((i, elem) => {
    window.PannableAttributes.deinit(elem)
  })
}

window.mountDraggableAttributes = mountDraggableAttributes
window.unmountDraggableAttributes = unmountDraggableAttributes
